module.exports = __webpack_public_path__ + "static/media/select2@2x.367bca6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/select2@2x.png
// module id = 830
// module chunks = 0